var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Banner'),_c('JoinSelect',{attrs:{"taskList":_vm.taskList}}),(_vm.taskList.length == 0)?_c('JoinSelectSkeleton'):_vm._e(),(_vm.showActiveAcount)?_c('AcountActive',{attrs:{"pass":_vm.pass},on:{"hideMask":_vm.hideMask}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }